<ag-grid-angular
  class="ag-theme-alpine"
  [serverSideInfiniteScroll]="true"
  [pagination]="true"
  [paginationPageSize]="paginationPageSize"
  [cacheBlockSize]="cacheBlockSize"
  [maxBlocksInCache]="maxBlocksInCache"
  [maxConcurrentDatasourceRequests]="maxConcurrentDatasourceRequests"
  [statusBar]="statusBar"
  [getContextMenuItems]="getContextMenuItems"
  [sideBar]="sideBar"
  [rowSelection]="rowSelection"
  [rowGroupPanelShow]="rowGroupPanelShow"
  [pivotPanelShow]="pivotPanelShow"
  [autoGroupColumnDef]="autoGroupColumnDef"
  [enableRangeSelection]="false"
  [rowModelType]="rowModelType"
  [columnDefs]="columnDefs"
  [suppressCopyRowsToClipboard]="true"
  [overlayLoadingTemplate]="overlayLoadingTemplate"
  [pinnedTopRowData]="pinnedTopRowData"
  [defaultColDef]="defaultColDef"
  [rowData]="rowData$ | async"
  [animateRows]="true"
  [suppressRowClickSelection]="false"
  [rowClassRules]="rowClassRules"
  [undoRedoCellEditing]="undoRedoCellEditing"
  [undoRedoCellEditingLimit]="undoRedoCellEditingLimit"
  [enableCellChangeFlash]="enableCellChangeFlash"
  [processCellForClipboard]="processCellForClipboard"
  [stopEditingWhenCellsLoseFocus]="false"
  (gridReady)="onGridReady($event)"
  (selectionChanged)="onSelectionChanged($event)"
  (cellClicked)="onCellClicked($event)"
  (cellEditingStarted)="cellEditingStarted($event)"
  (cellValueChanged)="cellValueChanged($event)"
  (cellEditingStopped)="cellEditingStopped($event)"
  (cellEditRequest)="cellEditRequest($event)"
  (filterChanged)="filterChanged($event)"
  (columnMoved)="columnEverythingChanged($event)"
  (columnResized)="columnEverythingChanged($event)"
  (columnPinned)="columnEverythingChanged($event)"
  (columnVisible)="columnEverythingChanged($event)"
></ag-grid-angular>
<!--[stopEditingWhenGridLosesFocus]="false"-->

